import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-186" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-5xl" data-id="element-187" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-188" data-mp="3fyvxs9ef7bak">
          <span aria-hidden="true" data-id="element-189" data-mp="3b01gxd00jwt3">💬 </span>Co mówią nauczyciele?
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-190" data-mp="3700qsv3jxx67">
          <span aria-hidden="true" data-id="element-191" data-mp="3205ziqfv75km">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +1 500
          nauczycieli
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-3" data-id="element-192" data-mp="2x0jqyuazedi5">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-193" data-mp="2s2i7475qea5m">
              <div className="text-sm text-amber-500" aria-label="5 gwiazdek na 5" data-id="element-194" data-mp="v8nbxaplulim">
                <span aria-hidden="true" data-id="element-195" data-mp="qava9oz5rl18">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-196" data-mp="h5opb9y5y46w">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-197" data-mp="780l7teo3kc2">
                <p className="text-xs font-bold text-ink" data-id="element-198" data-mp="79bntpwdmm1l">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-199" data-mp="c624aec3fjnj">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-200" data-mp="zx7qrccjha6t">
          Opinie mają charakter poglądowy.
        </p>
      </div>
    </section>;
}